/** Slugs de voz bajo `tracks/` (bitácoras nuevas). */
export const VOICE_CATEGORY_SLUGS = [
  'chicas',
  'chicos',
  'improvisacion',
] as const

export type VoiceCategorySlug = (typeof VOICE_CATEGORY_SLUGS)[number]

export const TRAINING_SUBFOLDER_SLUGS = [
  'belt',
  'flexibilidad_y_estimulacion_laringea',
  'lirico_y_legit',
  'optimizacion_resonancial',
  'trabajo_respiratorio',
] as const

export type TrainingSubfolderSlug = (typeof TRAINING_SUBFOLDER_SLUGS)[number]

export const VOICE_CATEGORY_LABELS: Record<VoiceCategorySlug, string> = {
  chicas: 'Chicas',
  chicos: 'Chicos',
  improvisacion: 'Improvisación',
}

export const TRAINING_TYPE_LABELS: Record<TrainingSubfolderSlug, string> = {
  belt: 'Belt',
  flexibilidad_y_estimulacion_laringea: 'Flexibilidad y estimulación laríngea',
  lirico_y_legit: 'Lírico y legit',
  optimizacion_resonancial: 'Optimización resonancial',
  trabajo_respiratorio: 'Trabajo respiratorio',
}

export const IMPROVISACION_ROUTINE_KEY = 'improvisacion'

/** Orden de grupos en el reproductor para el esquema nuevo (+ improvisación). */
export const ROUTINE_SECTION_ORDER: string[] = [
  ...TRAINING_SUBFOLDER_SLUGS,
  IMPROVISACION_ROUTINE_KEY,
]

export function routineSectionTitle(routine: string): string {
  if (routine === IMPROVISACION_ROUTINE_KEY) {
    return VOICE_CATEGORY_LABELS.improvisacion
  }
  if (routine in TRAINING_TYPE_LABELS) {
    return TRAINING_TYPE_LABELS[routine as TrainingSubfolderSlug]
  }
  return routine
}

/** Pestañas por defecto si `lists/trainingType` no incluye las nuevas. */
export const DEFAULT_TRAINING_TYPE_TABS: string[] = [...VOICE_CATEGORY_SLUGS]
